import { useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../i18n';
import { buildPageTitle, getTitleBadge, subscribeTitleBadge } from '../utils/pageTitle';

export default function usePageTitle() {
  const { pathname } = useLocation();
  const { t, language } = useI18n();
  const badge = useSyncExternalStore(subscribeTitleBadge, getTitleBadge);
  useEffect(() => {
    document.title = buildPageTitle(pathname, t, badge);
  }, [pathname, t, language, badge]);
}
